<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: {
    chartdata: {
      type: Object,
      default: null
    }, 
    options: {
      type: Object,
      default: null
    },
    isEmpty: {
      type: Object,
      default: null
    }
  },
  mounted() {
    Chart.defaults.global.defaultFontFamily = "'iransans'"
    // Overwriting base render method with actual data.
    if (false) {
      let canvas = this.$refs.canvas
      canvas.width = canvas.parentElement.offsetWidth
      var ctx = this.$refs.canvas.getContext('2d')

      ctx.font = '40px  iransans'
      ctx.direction = 'rtl'
      ctx.fillText('نمودار خالی است', canvas.width / 2 - 100, 50)
    } else {
      this.renderChart(this.chartdata, this.options)
    }
  }
}
</script>
